import React from 'react';
import styled from 'styled-components';

import downArrow from '~images/down-arrow.svg';
import upArrow from '~images/up-arrow.svg';

const ChevronButton = ({ up }) =>
  up ? (
    <Button>
      <img id="accordion_icon" alt="upArrow" src={upArrow} aria-hidden="true" />
    </Button>
  ) : (
    <Button>
      <img alt="downArrow" src={downArrow} aria-hidden="true" />
    </Button>
  );

const Button = styled.div`
  // background-color: #f7f7f7;
  border-radius: 50%;
  height: 32px;
  width: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  // border: 1px solid #f5f5f5;

  &:hover {
    background-color: #eee;
    border-color: #ccc;
  }

  &:active {
    background-color: #ddd;
  }

  & > img {
    max-width: 100%;
    width: 16px;
  }
`;

export default ChevronButton;
